// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/@rsbuild+core@1.7.3/node_modules/@rsbuild/core/compiled/css-loader/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/@rsbuild+core@1.7.3/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font-slim-l-activity-_DBOYM {
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
}

.login-form-yvzwvq .heading-SW_LAn {
  flex-direction: column;
  gap: 4px;
  margin-bottom: 32px;
  padding: 0 5px;
  display: flex;
}

.login-form-yvzwvq .title-fhOqkZ {
  color: #000;
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
}

.login-form-yvzwvq .subtitle-HNYUN7 {
  color: #000;
  margin: 0;
  font-size: 13px;
  line-height: 24px;
}

.login-form-yvzwvq .google-button-OVOv5c {
  height: var(--wg-login-google-button-height, 64px);
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  display: flex;
}

.login-form-yvzwvq .google-button-OVOv5c .google-icon-sGhs2Q {
  background-color: var(--js-color-bg-1);
  width: 40px;
  height: 40px;
  box-shadow: 0 1px 0 var(--wg-color-white), inset 0 1px 0 var(--wg-gray-2);
  border-radius: 50%;
  padding: 8px;
  font-size: 25px;
  display: flex;
}

.login-form-yvzwvq .divider-hJyJIJ {
  margin: var(--wg-login-divider-margin, 20px 0);
  padding: 8px 0;
}

.login-form-yvzwvq .forget-password-X8Ds_s {
  height: 44px;
  margin-bottom: var(--wg-login-forget-password-margin-bottom, 20px);
  color: var(--js-gray-9);
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 500;
  line-height: 24px;
}

.login-form-yvzwvq .forget-password-X8Ds_s:hover, .login-form-yvzwvq .forget-password-X8Ds_s:active {
  color: var(--js-color-black);
}

.login-form-yvzwvq .policy-TCeD2O {
  width: 100%;
  margin-top: var(--wg-login-policy-margin-top, 20px);
  color: var(--js-gray-7);
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}

.login-form-yvzwvq .link-tpJvQM {
  color: #0091ff;
  cursor: pointer;
  display: inline-block;
}

.login-form-yvzwvq .link-tpJvQM:hover {
  text-decoration: underline;
}

.login-form-yvzwvq .submit-button-sF2hi0 {
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
}

.invite-credits-f4hDWU {
  z-index: 0;
  vertical-align: middle;
  background: linear-gradient(180deg, var(--wg-white-3) 0%, #fff0 100%);
  border-radius: 8px;
  margin-left: 12px;
  padding: 4px 12px;
  display: inline-block;
  position: relative;
  overflow: hidden;
  box-shadow: 0 0 1px 1px #0000000a, 0 2px 4px #0000000a;
}

.invite-credits-f4hDWU:before {
  content: "";
  opacity: 0;
  background-image: linear-gradient(120deg, #fff0 30%, #fffc, #fff0 70%);
  width: 100%;
  height: 100%;
  animation: 1.6s ease-in-out infinite backwards shine-y8rIZ9;
  position: absolute;
  top: 0;
  left: -100%;
}

@keyframes shine-y8rIZ9 {
  0% {
    opacity: 0;
    left: -66%;
  }

  50% {
    opacity: .66;
    left: 25%;
  }

  100% {
    opacity: 0;
    left: 25%;
  }
}

.invite-credits-f4hDWU :after {
  z-index: -1;
  content: "";
  background: linear-gradient(180deg, var(--wg-white-7) 0%, #f7f6f5b3 100%);
  border-radius: 8px;
  position: absolute;
  inset: 1px;
}

.arco-message-wrapper .invite-message--available-PUvFsE {
  min-width: 537px;
  box-shadow: 0 0 0 1px #adde8b, inset 0 4px 4px 2px var(--wg-white-2), inset 0 0 0 1px var(--wg-white-3), inset 0 -12px 12px var(--wg-white-5);
  background: #64eda6;
  border-radius: 8px;
  padding: 6px 6px 6px 12px;
  top: -20px;
}

.arco-message-wrapper .invite-message--available-PUvFsE .arco-message-content {
  color: #000000e6;
}

.arco-message-wrapper .invite-message--unavailable-WY6Yok {
  background: var(--wg-color-bg-2);
  min-width: 537px;
  box-shadow: 0 1px 4px var(--wg-gray-2), inset 0 0 0 1px var(--wg-white-5), 0 0 0 1px #0000000a;
  border-radius: 8px;
  padding: 8px 12px;
  top: -20px;
}

.arco-message-wrapper .invite-message--unavailable-WY6Yok .arco-message-content {
  color: #000000e6;
}
`, "",{"version":3,"sources":["webpack://./root/packages/login/src/components/LoginForm/index.module.less","webpack://./src/components/LoginForm/index.module.less"],"names":[],"mappings":"AAAA;ECCE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kDAAkD;EAClD,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,yEAAyE;EACzE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kEAAkE;EAClE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,mDAAmD;EACnD,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,qEAAqE;EACrE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,UAAU;EACV,sEAAsE;EACtE,WAAW;EACX,YAAY;EACZ,2DAAoD;EACpD,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,UAAU;IACV,SAAS;EACX;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yEAAyE;EACzE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,6IAA6I;EAC7I,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,8FAA8F;EAC9F,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* font start */\n.font-slim-l-activity {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22px;\n}\n/* font end */\n.login-form .heading {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 32px;\n  padding: 0 5px;\n}\n.login-form .title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 28px;\n  color: #000;\n}\n.login-form .subtitle {\n  margin: 0;\n  font-size: 13px;\n  line-height: 24px;\n  color: #000;\n}\n.login-form .google-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: var(--wg-login-google-button-height, 64px);\n  width: 100%;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 24px;\n}\n.login-form .google-button .google-icon {\n  display: flex;\n  width: 40px;\n  height: 40px;\n  padding: 8px;\n  font-size: 25px;\n  background-color: var(--js-color-bg-1);\n  border-radius: 50%;\n  box-shadow: 0 1px 0 var(--wg-color-white), inset 0 1px 0 var(--wg-gray-2);\n}\n.login-form .divider {\n  padding: 8px 0;\n  margin: var(--wg-login-divider-margin, 20px 0);\n}\n.login-form .forget-password {\n  height: 44px;\n  padding: 10px 14px;\n  margin-bottom: var(--wg-login-forget-password-margin-bottom, 20px);\n  color: var(--js-gray-9);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 24px;\n}\n.login-form .forget-password:hover {\n  color: var(--js-color-black);\n}\n.login-form .forget-password:active {\n  color: var(--js-color-black);\n}\n.login-form .policy {\n  width: 100%;\n  margin-top: var(--wg-login-policy-margin-top, 20px);\n  color: var(--js-gray-7);\n  text-align: center;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n}\n.login-form .link {\n  display: inline-block;\n  color: #0091ff;\n  cursor: pointer;\n}\n.login-form .link:hover {\n  text-decoration: underline;\n}\n.login-form .submit-button {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 24px;\n}\n.invite-credits {\n  z-index: 0;\n  display: inline-block;\n  padding: 4px 12px;\n  margin-left: 12px;\n  vertical-align: middle;\n  background: linear-gradient(180deg, var(--wg-white-3) 0%, rgba(255, 255, 255, 0) 100%);\n  border-radius: 8px;\n  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.04);\n  position: relative;\n  overflow: hidden;\n}\n.invite-credits::before {\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  content: '';\n  background-image: linear-gradient(120deg, rgba(255, 255, 255, 0) 30%, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0) 70%);\n  opacity: 0;\n  animation: shine 1.6s ease-in-out infinite backwards;\n}\n@keyframes shine {\n  0% {\n    left: -66%;\n    opacity: 0;\n  }\n  50% {\n    left: 25%;\n    opacity: 0.66;\n  }\n  100% {\n    left: 25%;\n    opacity: 0;\n  }\n}\n.invite-credits ::after {\n  position: absolute;\n  inset: 1px;\n  z-index: -1;\n  content: '';\n  background: linear-gradient(180deg, var(--wg-white-7) 0%, rgba(247, 246, 245, 0.7) 100%);\n  border-radius: 8px;\n}\n:global(.arco-message-wrapper) .invite-message--available {\n  top: -20px;\n  min-width: 537px;\n  padding: 6px 6px 6px 12px;\n  background: #64eda6;\n  border-radius: 8px;\n  box-shadow: 0 0 0 1px #adde8b, inset 0 4px 4px 2px var(--wg-white-2), inset 0 0 0 1px var(--wg-white-3), inset 0 -12px 12px var(--wg-white-5);\n}\n:global(.arco-message-wrapper) .invite-message--available :global(.arco-message-content) {\n  color: rgba(0, 0, 0, 0.9);\n}\n:global(.arco-message-wrapper) .invite-message--unavailable {\n  top: -20px;\n  min-width: 537px;\n  padding: 8px 12px;\n  background: var(--wg-color-bg-2);\n  border-radius: 8px;\n  box-shadow: 0 1px 4px var(--wg-gray-2), inset 0 0 0 1px var(--wg-white-5), 0 0 0 1px rgba(0, 0, 0, 0.04);\n}\n:global(.arco-message-wrapper) .invite-message--unavailable :global(.arco-message-content) {\n  color: rgba(0, 0, 0, 0.9);\n}\n",".font-slim-l-activity {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22px;\n}\n\n.login-form .heading {\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 32px;\n  padding: 0 5px;\n  display: flex;\n}\n\n.login-form .title {\n  color: #000;\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 28px;\n}\n\n.login-form .subtitle {\n  color: #000;\n  margin: 0;\n  font-size: 13px;\n  line-height: 24px;\n}\n\n.login-form .google-button {\n  height: var(--wg-login-google-button-height, 64px);\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 24px;\n  display: flex;\n}\n\n.login-form .google-button .google-icon {\n  background-color: var(--js-color-bg-1);\n  width: 40px;\n  height: 40px;\n  box-shadow: 0 1px 0 var(--wg-color-white), inset 0 1px 0 var(--wg-gray-2);\n  border-radius: 50%;\n  padding: 8px;\n  font-size: 25px;\n  display: flex;\n}\n\n.login-form .divider {\n  margin: var(--wg-login-divider-margin, 20px 0);\n  padding: 8px 0;\n}\n\n.login-form .forget-password {\n  height: 44px;\n  margin-bottom: var(--wg-login-forget-password-margin-bottom, 20px);\n  color: var(--js-gray-9);\n  padding: 10px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.login-form .forget-password:hover, .login-form .forget-password:active {\n  color: var(--js-color-black);\n}\n\n.login-form .policy {\n  width: 100%;\n  margin-top: var(--wg-login-policy-margin-top, 20px);\n  color: var(--js-gray-7);\n  text-align: center;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n}\n\n.login-form .link {\n  color: #0091ff;\n  cursor: pointer;\n  display: inline-block;\n}\n\n.login-form .link:hover {\n  text-decoration: underline;\n}\n\n.login-form .submit-button {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.invite-credits {\n  z-index: 0;\n  vertical-align: middle;\n  background: linear-gradient(180deg, var(--wg-white-3) 0%, #fff0 100%);\n  border-radius: 8px;\n  margin-left: 12px;\n  padding: 4px 12px;\n  display: inline-block;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 0 1px 1px #0000000a, 0 2px 4px #0000000a;\n}\n\n.invite-credits:before {\n  content: \"\";\n  opacity: 0;\n  background-image: linear-gradient(120deg, #fff0 30%, #fffc, #fff0 70%);\n  width: 100%;\n  height: 100%;\n  animation: 1.6s ease-in-out infinite backwards shine;\n  position: absolute;\n  top: 0;\n  left: -100%;\n}\n\n@keyframes shine {\n  0% {\n    opacity: 0;\n    left: -66%;\n  }\n\n  50% {\n    opacity: .66;\n    left: 25%;\n  }\n\n  100% {\n    opacity: 0;\n    left: 25%;\n  }\n}\n\n.invite-credits :after {\n  z-index: -1;\n  content: \"\";\n  background: linear-gradient(180deg, var(--wg-white-7) 0%, #f7f6f5b3 100%);\n  border-radius: 8px;\n  position: absolute;\n  inset: 1px;\n}\n\n:global(.arco-message-wrapper) .invite-message--available {\n  min-width: 537px;\n  box-shadow: 0 0 0 1px #adde8b, inset 0 4px 4px 2px var(--wg-white-2), inset 0 0 0 1px var(--wg-white-3), inset 0 -12px 12px var(--wg-white-5);\n  background: #64eda6;\n  border-radius: 8px;\n  padding: 6px 6px 6px 12px;\n  top: -20px;\n}\n\n:global(.arco-message-wrapper) .invite-message--available :global(.arco-message-content) {\n  color: #000000e6;\n}\n\n:global(.arco-message-wrapper) .invite-message--unavailable {\n  background: var(--wg-color-bg-2);\n  min-width: 537px;\n  box-shadow: 0 1px 4px var(--wg-gray-2), inset 0 0 0 1px var(--wg-white-5), 0 0 0 1px #0000000a;\n  border-radius: 8px;\n  padding: 8px 12px;\n  top: -20px;\n}\n\n:global(.arco-message-wrapper) .invite-message--unavailable :global(.arco-message-content) {\n  color: #000000e6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"font-slim-l-activity": `font-slim-l-activity-_DBOYM`,
	"fontSlimLActivity": `font-slim-l-activity-_DBOYM`,
	"login-form": `login-form-yvzwvq`,
	"loginForm": `login-form-yvzwvq`,
	"heading": `heading-SW_LAn`,
	"title": `title-fhOqkZ`,
	"subtitle": `subtitle-HNYUN7`,
	"google-button": `google-button-OVOv5c`,
	"googleButton": `google-button-OVOv5c`,
	"google-icon": `google-icon-sGhs2Q`,
	"googleIcon": `google-icon-sGhs2Q`,
	"divider": `divider-hJyJIJ`,
	"forget-password": `forget-password-X8Ds_s`,
	"forgetPassword": `forget-password-X8Ds_s`,
	"policy": `policy-TCeD2O`,
	"link": `link-tpJvQM`,
	"submit-button": `submit-button-sF2hi0`,
	"submitButton": `submit-button-sF2hi0`,
	"invite-credits": `invite-credits-f4hDWU`,
	"inviteCredits": `invite-credits-f4hDWU`,
	"shine": `shine-y8rIZ9`,
	"invite-message--available": `invite-message--available-PUvFsE`,
	"inviteMessageAvailable": `invite-message--available-PUvFsE`,
	"invite-message--unavailable": `invite-message--unavailable-WY6Yok`,
	"inviteMessageUnavailable": `invite-message--unavailable-WY6Yok`
};
export default ___CSS_LOADER_EXPORT___;
